import { html as runeHtml } from 'rune-ts';
import { html as fxjsHtml } from 'fxjs/es';

type IconProps = {
  html?: typeof runeHtml | typeof fxjsHtml;
  klass?: string;
};

export const makeFundingIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12.8802 18.29V11.68C15.2902 11.83 18.2402 11.11 19.9302 9.42003C21.7802 7.56003 21.9902 5.69003 22.0002 2.61003C22.0002 2.27003 21.7302 2.00003 21.3902 2.01003C19.9602 2.05003 16.4002 2.34003 14.6702 4.08003C12.8702 5.88003 12.1202 7.74004 11.8502 9.55003C11.3002 8.45004 10.4902 7.37004 9.25022 6.36003C7.40022 4.85003 3.93022 4.93004 2.54022 5.03004C2.21022 5.05003 1.97022 5.35003 2.01022 5.68003C2.33022 8.66003 2.72022 10.45 4.69022 12.06C6.34022 13.4 8.92022 13.85 11.1302 13.62V18.3C6.02022 18.49 4.29022 20.35 4.10022 20.57C3.79022 20.94 3.83022 21.49 4.20022 21.81C4.57022 22.12 5.12022 22.08 5.43022 21.71C5.44022 21.69 7.00022 20.04 12.0102 20.04C17.0202 20.04 18.5402 21.67 18.6002 21.72C18.7702 21.92 19.0102 22.02 19.2602 22.02C19.4602 22.02 19.6602 21.95 19.8302 21.81C20.2002 21.5 20.2402 20.94 19.9302 20.57C19.7402 20.35 18.0002 18.5 12.9002 18.3L12.8802 18.29Z"
      fill="currentColor"
    />
  </svg>
`;

export const makePODIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M20.8598 6.52963C20.1198 5.05963 18.8298 3.94963 17.2798 3.43963L15.6498 2.89963C15.3798 2.80963 15.0898 2.96963 15.0198 3.24963C14.6998 4.62963 13.4698 5.64963 11.9998 5.64963C10.5298 5.64963 9.29981 4.61963 8.97981 3.24963C8.91981 2.96963 8.61981 2.80963 8.34981 2.89963L6.71981 3.43963C5.15981 3.95963 3.87981 5.06963 3.13981 6.52963L2.05981 8.64963C1.91981 8.91963 2.05981 9.23963 2.33981 9.33963L5.63981 10.4996C5.91981 10.5996 6.09981 10.8596 6.09981 11.1496V20.2796C6.09981 20.7396 6.46981 21.1096 6.92981 21.1096H17.0698C17.5298 21.1096 17.8998 20.7396 17.8998 20.2796V11.1496C17.8998 10.8596 18.0898 10.5896 18.3598 10.4996L21.6598 9.33963C21.9398 9.23963 22.0698 8.91963 21.9398 8.64963L20.8598 6.52963Z"
      fill="currentColor"
    />
  </svg>
`;

export const makeDigitalIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M17.25 2H6.75C5.65 2 4.75 2.9 4.75 4V20C4.75 21.1 5.65 22 6.75 22H17.25C18.35 22 19.25 21.1 19.25 20V4C19.25 2.9 18.35 2 17.25 2ZM12 20.25C11.31 20.25 10.75 19.69 10.75 19C10.75 18.31 11.31 17.75 12 17.75C12.69 17.75 13.25 18.31 13.25 19C13.25 19.69 12.69 20.25 12 20.25ZM16.38 5.5H7.63C7.15 5.5 6.75 5.11 6.75 4.62C6.75 4.13 7.14 3.74 7.63 3.74H16.38C16.86 3.74 17.26 4.13 17.26 4.62C17.26 5.11 16.87 5.5 16.38 5.5Z"
      fill="currentColor"
    />
  </svg>
`;

export const makeCreatorDesignIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) =>
  html`<svg
    class="${klass}"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Nav Icon">
      <path
        id="Vector"
        d="M16.8669 1.85768C16.7502 1.74102 16.5835 1.66602 16.4169 1.66602H5.51686C4.83353 1.66602 4.18353 1.93268 3.7002 2.41602C3.21686 2.89935 2.9502 3.54935 2.9502 4.23268V17.0577C2.9502 17.766 3.5252 18.341 4.23353 18.341H13.2585C13.6585 18.341 13.9919 18.016 13.9919 17.6077C13.9919 17.1993 13.6669 16.8743 13.2585 16.8743H4.84186C5.3252 16.116 6.1752 15.6077 7.14186 15.6077H15.7752C16.4835 15.6077 17.0585 15.0327 17.0585 14.3244V2.30768C17.0585 2.14102 16.9919 1.97435 16.8669 1.85768ZM14.4835 9.35768L12.4335 7.81602C12.3752 7.77435 12.3085 7.74935 12.2419 7.74935C12.1752 7.74935 12.1085 7.77435 12.0502 7.81602L10.0002 9.35768V2.94935H14.4835V9.35768Z"
        fill="currentColor"
      />
    </g>
  </svg> `;

export const makePBIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M21.71 11.71L12.29 2.29C12.1 2.1 11.85 2 11.58 2H3C2.45 2 2 2.45 2 3V11.59C2 11.86 2.11 12.11 2.29 12.3L11.7 21.71C12.09 22.1 12.72 22.1 13.11 21.71L21.7 13.12C22.09 12.73 22.09 12.1 21.7 11.71H21.71ZM6.25 7.5C5.56 7.5 5 6.94 5 6.25C5 5.56 5.56 5 6.25 5C6.94 5 7.5 5.56 7.5 6.25C7.5 6.94 6.94 7.5 6.25 7.5Z"
      fill="currentColor"
    />
  </svg>
`;

export const makeInquiryIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 2C6.48 2 2 6.48 2 12V17.06C2 17.89 2.67 18.56 3.5 18.56H6.51C7.34 18.56 8.01 17.89 8.01 17.06V12.23C8.01 11.4 7.34 10.73 6.51 10.73H3.85C4.46 6.78 7.88 3.75 11.99 3.75C16.1 3.75 19.52 6.78 20.13 10.73H17.47C16.64 10.73 15.97 11.4 15.97 12.23V17.06C15.97 17.89 16.64 18.56 17.47 18.56H20.23C20.23 19.49 19.47 20.25 18.54 20.25H12.85C12.37 20.25 11.97 20.64 11.97 21.13C11.97 21.62 12.36 22.01 12.85 22.01H18.54C20.44 22.01 21.98 20.47 21.98 18.57V12.01C21.98 6.49 17.5 2.01 11.98 2.01L12 2Z"
      fill="currentColor"
    />
  </svg>
`;

export const makeShopIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M20.25 3.23C19.95 2.29 19.48 2 18.8 2H5.2C4.52 2 4.06 2.28 3.75 3.23C3.55 3.86 2.83 6.08 2.38 7.48C2.13 8.27 2 9.09 2 9.93C2 11.3 2.72 12.51 3.81 13.21C3.79 13.2 3.77 13.19 3.75 13.18V20.79C3.75 21.47 4.3 22.02 4.98 22.02H19.03C19.71 22.02 20.26 21.47 20.26 20.79V13.18C20.26 13.18 20.22 13.2 20.2 13.21C21.28 12.52 22.01 11.31 22.01 9.94C22.01 9.11 21.88 8.29 21.63 7.49C21.18 6.09 20.47 3.87 20.26 3.24L20.25 3.23ZM8.04 9.92C8.04 11.1 7.08 12.06 5.9 12.06C4.72 12.06 3.76 11.1 3.76 9.92V8.66H8.05V9.92H8.04ZM14.15 9.92C14.15 11.1 13.19 12.07 12 12.07C10.81 12.07 9.85 11.11 9.85 9.92V8.67H14.14V9.92H14.15ZM20.25 9.92C20.25 11.1 19.29 12.07 18.1 12.07C16.91 12.07 15.95 11.11 15.95 9.92V8.67H20.24V9.92H20.25Z"
      fill="currentColor"
    />
  </svg>
`;

export const makeCalculateIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M18.92 2H5.08004C4.67004 2 4.28004 2.16 3.99004 2.45C3.70004 2.74 3.54004 3.13 3.54004 3.54V20.46C3.54004 20.87 3.70004 21.26 3.99004 21.55C4.28004 21.84 4.67004 22 5.08004 22H18.93C19.34 22 19.73 21.84 20.02 21.55C20.31 21.26 20.47 20.87 20.47 20.46V3.54C20.47 3.13 20.31 2.74 20.02 2.45C19.73 2.16 19.34 2 18.93 2H18.92ZM8.15004 18.92C7.92004 18.92 7.70004 18.85 7.51004 18.73C7.32004 18.6 7.17004 18.42 7.08004 18.21C6.99004 18 6.97004 17.77 7.01004 17.54C7.05004 17.32 7.16004 17.11 7.33004 16.95C7.49004 16.79 7.70004 16.68 7.92004 16.63C8.14004 16.59 8.38004 16.61 8.59004 16.7C8.80004 16.79 8.98004 16.94 9.11004 17.13C9.24004 17.32 9.30004 17.54 9.30004 17.77C9.30004 18.08 9.18004 18.37 8.96004 18.59C8.74004 18.81 8.45004 18.93 8.14004 18.93L8.15004 18.92ZM8.15004 15.08C7.92004 15.08 7.70004 15.01 7.51004 14.89C7.32004 14.76 7.17004 14.58 7.08004 14.37C6.99004 14.16 6.97004 13.93 7.01004 13.7C7.05004 13.48 7.16004 13.27 7.33004 13.11C7.49004 12.95 7.70004 12.84 7.92004 12.79C8.14004 12.75 8.38004 12.77 8.59004 12.86C8.80004 12.95 8.98004 13.1 9.11004 13.29C9.24004 13.48 9.30004 13.7 9.30004 13.93C9.30004 14.24 9.18004 14.53 8.96004 14.75C8.74004 14.97 8.45004 15.09 8.14004 15.09L8.15004 15.08ZM12 18.92C11.77 18.92 11.55 18.85 11.36 18.73C11.17 18.6 11.02 18.42 10.93 18.21C10.84 18 10.82 17.77 10.86 17.54C10.9 17.32 11.01 17.11 11.18 16.95C11.34 16.79 11.55 16.68 11.77 16.63C11.99 16.59 12.23 16.61 12.44 16.7C12.65 16.79 12.83 16.94 12.96 17.13C13.09 17.32 13.15 17.54 13.15 17.77C13.15 18.08 13.03 18.37 12.81 18.59C12.59 18.81 12.3 18.93 11.99 18.93L12 18.92ZM12 15.08C11.77 15.08 11.55 15.01 11.36 14.89C11.17 14.76 11.02 14.58 10.93 14.37C10.84 14.16 10.82 13.93 10.86 13.7C10.9 13.48 11.01 13.27 11.18 13.11C11.34 12.95 11.55 12.84 11.77 12.79C11.99 12.75 12.23 12.77 12.44 12.86C12.65 12.95 12.83 13.1 12.96 13.29C13.09 13.48 13.15 13.7 13.15 13.93C13.15 14.24 13.03 14.53 12.81 14.75C12.59 14.97 12.3 15.09 11.99 15.09L12 15.08ZM15.85 18.92C15.62 18.92 15.4 18.85 15.21 18.73C15.02 18.6 14.87 18.42 14.78 18.21C14.69 18 14.67 17.77 14.71 17.54C14.75 17.32 14.86 17.11 15.03 16.95C15.19 16.79 15.4 16.68 15.62 16.63C15.84 16.59 16.08 16.61 16.29 16.7C16.5 16.79 16.68 16.94 16.81 17.13C16.94 17.32 17 17.54 17 17.77C17 18.08 16.88 18.37 16.66 18.59C16.44 18.81 16.15 18.93 15.84 18.93L15.85 18.92ZM15.85 15.08C15.62 15.08 15.4 15.01 15.21 14.89C15.02 14.76 14.87 14.58 14.78 14.37C14.69 14.16 14.67 13.93 14.71 13.7C14.75 13.48 14.86 13.27 15.03 13.11C15.19 12.95 15.4 12.84 15.62 12.79C15.84 12.75 16.08 12.77 16.29 12.86C16.5 12.95 16.68 13.1 16.81 13.29C16.94 13.48 17 13.7 17 13.93C17 14.24 16.88 14.53 16.66 14.75C16.44 14.97 16.15 15.09 15.84 15.09L15.85 15.08ZM17.38 9.69C17.38 9.89 17.3 10.09 17.15 10.23C17.01 10.37 16.81 10.46 16.61 10.46H7.38004C7.18004 10.46 6.98004 10.38 6.84004 10.23C6.70004 10.09 6.61004 9.89 6.61004 9.69V5.84C6.61004 5.64 6.69004 5.44 6.84004 5.3C6.98004 5.16 7.18004 5.07 7.38004 5.07H16.61C16.81 5.07 17.01 5.15 17.15 5.3C17.29 5.44 17.38 5.64 17.38 5.84V9.69Z"
      fill="currentColor"
    />
  </svg>
`;

export const makeStatisticsIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M21.0002 10.0002H3.75023V8.09023H16.1602C16.6302 8.09023 17.0102 7.71023 17.0102 7.24023V4.94023C17.0102 4.47023 16.6302 4.09023 16.1602 4.09023H3.75023V2.87023C3.75023 2.39023 3.36023 1.99023 2.87023 1.99023C2.38023 1.99023 1.99023 2.38023 1.99023 2.87023V21.1202C1.99023 21.6002 2.38023 22.0002 2.87023 22.0002C3.36023 22.0002 3.75023 21.6102 3.75023 21.1202V19.9002H12.9302C13.3402 19.9002 13.6702 19.5702 13.6702 19.1602V16.6302C13.6702 16.2202 13.3402 15.8902 12.9302 15.8902H3.75023V13.9802H21.0002C21.5502 13.9802 22.0002 13.5302 22.0002 12.9802V10.9802C22.0002 10.4302 21.5502 9.98023 21.0002 9.98023V10.0002Z"
      fill="currentColor"
    />
  </svg>
`;

export const makeYoutubeIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M21.489 6.78014C21.409 6.45014 21.249 6.15014 21.019 5.89014C20.789 5.64014 20.509 5.44014 20.199 5.31014C17.139 4.13014 12.269 4.14014 11.999 4.14014C11.729 4.14014 6.85902 4.13014 3.79902 5.31014C3.47902 5.43014 3.19902 5.63014 2.97902 5.89014C2.74902 6.14014 2.58902 6.45014 2.50902 6.78014C2.27902 7.67014 1.99902 9.30014 1.99902 12.0001C1.99902 14.7001 2.27902 16.3301 2.50902 17.2201C2.58902 17.5501 2.74902 17.8501 2.97902 18.1101C3.20902 18.3701 3.48902 18.5601 3.79902 18.6901C6.72902 19.8201 11.319 19.8601 11.939 19.8601H12.059C12.679 19.8601 17.269 19.8201 20.199 18.6901C20.519 18.5701 20.799 18.3701 21.019 18.1101C21.249 17.8601 21.409 17.5501 21.489 17.2201C21.719 16.3301 21.999 14.7001 21.999 12.0001C21.999 9.30014 21.719 7.67014 21.489 6.78014ZM14.909 12.5801L11.339 15.0801C11.229 15.1601 11.109 15.2001 10.979 15.2101C10.849 15.2101 10.719 15.1901 10.599 15.1301C10.479 15.0701 10.389 14.9801 10.319 14.8701C10.249 14.7601 10.219 14.6301 10.209 14.5001V9.50014C10.209 9.37014 10.249 9.24014 10.309 9.13014C10.379 9.02014 10.479 8.93014 10.589 8.87014C10.709 8.81014 10.839 8.78014 10.969 8.79014C11.099 8.79014 11.229 8.84014 11.329 8.92014L14.899 11.4201C14.989 11.4901 15.069 11.5701 15.119 11.6801C15.169 11.7801 15.199 11.8901 15.199 12.0101C15.199 12.1301 15.169 12.2401 15.119 12.3401C15.069 12.4401 14.989 12.5301 14.899 12.6001L14.909 12.5801Z"
      fill="currentColor"
    />
  </svg>
`;

export const makeGuideIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M20.24 2.23C20.1 2.09 19.9 2 19.7 2H6.62004C5.80004 2 5.02004 2.32 4.44004 2.9C3.86004 3.48 3.54004 4.26 3.54004 5.08V20.47C3.54004 21.32 4.23004 22.01 5.08004 22.01H15.91C16.39 22.01 16.79 21.62 16.79 21.13C16.79 20.64 16.4 20.25 15.91 20.25H5.81004C6.39004 19.34 7.41004 18.73 8.57004 18.73H18.93C19.78 18.73 20.47 18.04 20.47 17.19V2.77C20.47 2.57 20.39 2.37 20.24 2.23ZM17.38 11.23L14.92 9.38C14.85 9.33 14.77 9.3 14.69 9.3C14.61 9.3 14.53 9.33 14.46 9.38L12 11.23V3.54H17.38V11.23Z"
      fill="currentColor"
    />
  </svg>
`;

export const makeTipsIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M15.4104 20.2499H8.59045C8.11045 20.2499 7.71045 20.6399 7.71045 21.1299C7.71045 21.6199 8.10045 22.0099 8.59045 22.0099H15.4104C15.8904 22.0099 16.2905 21.6199 16.2905 21.1299C16.2905 20.6399 15.9004 20.2499 15.4104 20.2499Z"
      fill="currentColor"
    />
    <path
      d="M10.4604 2.14986C7.42045 2.73986 5.00045 5.20986 4.45045 8.24986C3.92045 11.1599 5.04045 13.8499 7.03045 15.5399C7.47045 15.9199 7.73045 16.4699 7.73045 17.0499V17.4999C7.73045 18.0499 8.18045 18.4999 8.73045 18.4999H15.3004C15.8504 18.4999 16.3004 18.0499 16.3004 17.4999V17.0499C16.3004 16.4699 16.5504 15.9199 17.0004 15.5399C18.6504 14.1299 19.7004 12.0299 19.7004 9.68986C19.7004 4.93986 15.3904 1.19986 10.4704 2.14986H10.4604ZM16.8304 8.59986C16.7204 8.64986 16.6004 8.66986 16.4904 8.66986C16.1504 8.66986 15.8204 8.46986 15.6804 8.13986C15.0504 6.65986 13.6104 5.69986 12.0004 5.69986C11.5204 5.69986 11.1204 5.30986 11.1204 4.81986C11.1204 4.32986 11.5104 3.93986 12.0004 3.93986C14.3104 3.93986 16.3904 5.31986 17.3004 7.44986C17.4904 7.88986 17.2804 8.40986 16.8404 8.59986H16.8304Z"
      fill="currentColor"
    />
  </svg>
`;

export const makeFAQIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M21.9013 19.5899L21.3416 17.9099C21.7314 17.0599 21.9613 16.1299 21.9913 15.1899C22.0313 14.1199 21.8214 13.0499 21.3816 12.0699C20.9517 11.0999 20.292 10.2199 19.4724 9.52989C18.6628 8.84989 17.6832 8.34989 16.6436 8.08989C16.1738 7.96989 15.7041 7.90989 15.2143 7.88989C15.1343 7.13989 14.9144 6.40989 14.5845 5.71989C14.1447 4.80989 13.505 4.01989 12.7054 3.39989C11.9157 2.77989 10.9861 2.34989 10.0066 2.13989C9.017 1.92989 7.99745 1.94989 7.02788 2.18989C6.04831 2.42989 5.13871 2.89989 4.36905 3.54989C3.59939 4.19989 2.97966 5.00989 2.56984 5.92989C2.16002 6.84989 1.97011 7.84989 2.00009 8.85989C2.04007 9.86989 2.29996 10.8499 2.76975 11.7399L2.05007 13.9099C1.9901 14.0899 1.9801 14.2799 2.02008 14.4699C2.06007 14.6499 2.16002 14.8199 2.28996 14.9599C2.41991 15.0899 2.58983 15.1899 2.77975 15.2299C2.95967 15.2699 3.15958 15.2599 3.3395 15.1999L5.50855 14.4799C6.24822 14.8699 7.05786 15.1199 7.8875 15.2099C7.92748 16.3299 8.22735 17.4299 8.7871 18.4099C9.38684 19.4699 10.2565 20.3599 11.296 20.9899C12.3355 21.6199 13.535 21.9699 14.7445 21.9999C14.8045 21.9999 14.8644 21.9999 14.9244 21.9999C15.9539 21.9999 16.9635 21.7699 17.9031 21.3399L19.5823 21.8999C19.9022 22.0099 20.2521 22.0199 20.5819 21.9399C20.9118 21.8599 21.2116 21.6899 21.4515 21.4499C21.6914 21.2099 21.8613 20.9099 21.9413 20.5799C22.0213 20.2499 22.0013 19.8999 21.9013 19.5799V19.5899ZM19.5624 18.1199L20.2421 20.1899L20.1421 20.2499L18.113 19.5699C17.8831 19.4899 17.6332 19.5099 17.4233 19.6299C16.6137 20.0599 15.6941 20.2699 14.7945 20.2499C13.8749 20.2299 12.9853 19.9599 12.1956 19.4899C11.4059 19.0199 10.7562 18.3499 10.3064 17.5499C9.89661 16.8299 9.67671 16.0099 9.63673 15.1799C10.4864 15.0499 11.306 14.7599 12.0457 14.3099C13.0252 13.7199 13.8349 12.8899 14.4046 11.8899C14.8045 11.1899 15.0543 10.4199 15.1743 9.62989C15.5241 9.64989 15.874 9.68989 16.2138 9.76989C16.9935 9.96989 17.7332 10.3399 18.3429 10.8599C18.9526 11.3799 19.4524 12.0399 19.7823 12.7699C20.1121 13.4999 20.262 14.3099 20.2421 15.1199C20.2121 15.9199 20.0022 16.7199 19.6223 17.4299C19.5124 17.6399 19.4924 17.8899 19.5624 18.1199Z"
      fill="currentColor"
    />
  </svg>
`;

export const makeHomeIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M11.38 2.21994L2.38 9.41994C2.14 9.60994 2 9.89994 2 10.1999V20.9999C2 21.5499 2.45 21.9999 3 21.9999H8.5C9.05 21.9999 9.5 21.5499 9.5 20.9999V16.4999C9.5 15.1199 10.62 13.9999 12 13.9999C13.38 13.9999 14.5 15.1199 14.5 16.4999V20.9999C14.5 21.5499 14.95 21.9999 15.5 21.9999H21C21.55 21.9999 22 21.5499 22 20.9999V10.1999C22 9.89994 21.86 9.60994 21.62 9.41994L12.62 2.21994C12.25 1.92994 11.74 1.92994 11.37 2.21994H11.38Z"
      fill="currentColor"
    />
  </svg>
`;

export const makeDashboardIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M20.5 3H3.5C2.67 3 2 3.67 2 4.5V19.5C2 20.33 2.67 21 3.5 21H20.5C21.33 21 22 20.33 22 19.5V4.5C22 3.67 21.33 3 20.5 3ZM18.13 18H5.88C5.4 18 5 17.61 5 17.12V6.88C5 6.4 5.39 6 5.88 6C6.37 6 6.76 6.39 6.76 6.88V14.93L10.7 10.48C11 10.14 11.53 10.09 11.89 10.37L13.96 11.97L17.49 8.18C17.82 7.83 18.37 7.81 18.73 8.14C19.08 8.47 19.1 9.02 18.77 9.38L14.69 13.75C14.38 14.08 13.87 14.12 13.51 13.85L11.45 12.26L7.91 16.26H18.12C18.6 16.26 19 16.65 19 17.14C19 17.63 18.61 18.02 18.12 18.02L18.13 18Z"
      fill="currentColor"
    />
  </svg>
`;

export const makeCircleChartIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_608_22344)">
      <path
        d="M8.91 14.8001L4.83 17.1601C4.28 17.4801 4.15 18.2201 4.57 18.6901C5.96 20.2301 7.82 21.3401 9.93 21.7901C10.55 21.9201 11.13 21.4401 11.13 20.8001V16.0801C11.13 15.7001 10.91 15.3401 10.56 15.1901C10.35 15.1001 10.15 14.9801 9.96 14.8501C9.65 14.6301 9.24 14.6201 8.91 14.8101V14.8001Z"
        fill="currentColor"
      />
      <path
        d="M2 12.0001C2 13.0801 2.18 14.1201 2.5 15.1001C2.7 15.7001 3.41 15.9501 3.95 15.6401L8.64 12.9301C8.56 12.6301 8.5 12.3201 8.5 12.0001C8.5 11.6601 8.55 11.3201 8.65 11.0101C8.79 10.5501 8.63 10.0501 8.21 9.81014L4.26 7.53014C3.75 7.23014 3.08 7.44014 2.84 7.99014C2.3 9.22014 2 10.5701 2 12.0001Z"
        fill="currentColor"
      />
      <path
        d="M12 3.06014V7.62014C12 8.10014 12.34 8.49014 12.8 8.59014C14.35 8.95014 15.5 10.3401 15.5 12.0001C15.5 13.4201 14.65 14.6301 13.44 15.1801C13.09 15.3401 12.87 15.6901 12.87 16.0701V20.7901C12.87 21.4201 13.45 21.9101 14.07 21.7801C18.6 20.8201 21.99 16.8101 21.99 12.0001C21.99 6.86014 18.11 2.62014 13.11 2.06014C12.51 1.99014 11.99 2.46014 11.99 3.06014H12Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_608_22344">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;

export const makeReportIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12.001 4.52023C12.481 4.52023 12.881 4.13023 12.881 3.64023V2.87023C12.881 2.39023 12.491 1.99023 12.001 1.99023C11.511 1.99023 11.121 2.38023 11.121 2.87023V3.64023C11.121 4.12023 11.511 4.52023 12.001 4.52023Z"
      fill="currentColor"
    />
    <path
      d="M5.27098 6.28023C5.44098 6.49023 5.69098 6.59023 5.94098 6.59023C6.14098 6.59023 6.34098 6.52023 6.50098 6.39023C6.87098 6.08023 6.92098 5.53023 6.61098 5.16023L6.11098 4.57023C5.80098 4.20023 5.25098 4.15023 4.88098 4.46023C4.51098 4.77023 4.46098 5.32023 4.77098 5.69023L5.27098 6.28023Z"
      fill="currentColor"
    />
    <path
      d="M18.061 6.59023C18.311 6.59023 18.561 6.48023 18.731 6.28023L19.231 5.69023C19.541 5.32023 19.491 4.77023 19.121 4.46023C18.751 4.15023 18.201 4.20023 17.891 4.57023L17.391 5.16023C17.081 5.53023 17.131 6.08023 17.501 6.39023C17.661 6.53023 17.861 6.59023 18.061 6.59023Z"
      fill="currentColor"
    />
    <path
      d="M20.171 16.2502H20.001V13.7902C20.001 9.37023 16.421 5.79023 12.001 5.79023C7.58098 5.79023 4.00098 9.37023 4.00098 13.7902V16.2502H3.83098C2.82098 16.2502 2.00098 17.0702 2.00098 18.0802V20.1702C2.00098 21.1802 2.82098 22.0002 3.83098 22.0002H20.171C21.181 22.0002 22.001 21.1802 22.001 20.1702V18.0802C22.001 17.0702 21.181 16.2502 20.171 16.2502ZM13.581 8.68023C13.811 8.26024 14.351 8.11023 14.771 8.34023C16.191 9.13023 17.291 10.4002 17.871 11.9102C18.041 12.3602 17.821 12.8702 17.371 13.0402C17.271 13.0802 17.161 13.1002 17.061 13.1002C16.711 13.1002 16.381 12.8902 16.241 12.5402C15.811 11.4102 14.981 10.4602 13.921 9.87023C13.501 9.63023 13.351 9.10023 13.581 8.68023ZM20.251 20.1702C20.251 20.1702 20.211 20.2502 20.171 20.2502H3.83098C3.83098 20.2502 3.75098 20.2102 3.75098 20.1702V18.0802C3.75098 18.0802 3.79098 18.0002 3.83098 18.0002H20.171C20.171 18.0002 20.251 18.0402 20.251 18.0802V20.1702Z"
      fill="currentColor"
    />
  </svg>
`;

export const makePeopleIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 10.5C14.346 10.5 16.2478 8.59721 16.2478 6.25C16.2478 3.90279 14.346 2 12 2C9.65406 2 7.75227 3.90279 7.75227 6.25C7.75227 8.59721 9.65406 10.5 12 10.5Z"
      fill="currentColor"
    />
    <path
      d="M12 12C6.82275 12 2.55498 15.9 2.00526 20.9C1.9453 21.49 2.40506 22 3.00474 22H20.9954C21.585 22 22.0548 21.49 21.9948 20.9C21.4451 15.89 17.1873 12 12.01 12H12Z"
      fill="currentColor"
    />
  </svg>
`;

export const makeErrorIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_608_22324)">
      <path
        d="M21.7498 17.8102L13.2998 4.47018C12.6898 3.50018 11.2998 3.50018 10.6798 4.47018L2.24983 17.8202C1.58983 18.8702 2.32983 20.2502 3.55983 20.2502H20.4398C21.6698 20.2502 22.4098 18.8702 21.7498 17.8102ZM11.9998 17.9202C11.5198 17.9202 11.1198 17.5302 11.1198 17.0402C11.1198 16.5502 11.5098 16.1602 11.9998 16.1602C12.4898 16.1602 12.8798 16.5502 12.8798 17.0402C12.8798 17.5302 12.4898 17.9202 11.9998 17.9202ZM12.8798 13.8302C12.8798 14.3102 12.4898 14.7102 11.9998 14.7102C11.5098 14.7102 11.1198 14.3202 11.1198 13.8302V9.34018C11.1198 8.86018 11.5098 8.46018 11.9998 8.46018C12.4898 8.46018 12.8798 8.85018 12.8798 9.34018V13.8302Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_608_22324">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;

export const makeMoneyIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M21.4 10.0702H21.16C21.16 10.0702 20.39 10.0402 20.18 9.2502C19.99 8.5402 19.61 7.5102 18.95 6.8402C18.82 6.7102 18.79 6.5102 18.89 6.3502L20.02 4.4802C20.21 4.1602 20.07 3.7402 19.71 3.6102C19.13 3.3902 18.17 3.1602 16.8 3.2902C16.15 3.3502 15.7 3.5802 15.42 3.7802C15.18 3.9602 14.86 4.0002 14.57 3.9302C13.3 3.5802 9.85001 2.9402 6.67001 5.0802C5.94001 5.5702 5.34001 6.0902 4.87001 6.6102C4.71001 6.5002 4.55001 6.3402 4.51001 6.0802C4.40001 5.4002 3.76001 4.9302 3.08001 5.0302C2.40001 5.1402 1.93001 5.7802 2.03001 6.4602C2.20001 7.5402 2.84001 8.2602 3.49001 8.7002C2.84001 10.1702 2.87001 11.4402 2.87001 11.9502C2.87001 12.8102 3.21001 15.1702 4.93001 16.8302C5.13001 17.0202 5.24001 17.2802 5.24001 17.5502V19.9502C5.24001 20.3902 5.60001 20.7502 6.04001 20.7502H8.57001C8.87001 20.7502 9.13001 20.5302 9.17001 20.2302L9.23001 19.7902C9.27001 19.4902 9.52001 19.2702 9.83001 19.2702H13.74C14.04 19.2702 14.3 19.4902 14.34 19.7902L14.4 20.2302C14.44 20.5302 14.69 20.7502 15 20.7502H17.53C17.97 20.7502 18.33 20.3902 18.33 19.9502V17.5002C18.33 17.2102 18.46 16.9202 18.68 16.7402C18.81 16.6302 18.95 16.5102 19.04 16.3802C19.27 16.0702 19.39 15.4402 19.95 15.3402C20.3 15.2702 21.03 15.1602 21.52 15.0802C21.81 15.0302 22.03 14.7802 22.03 14.4902V10.6902C22.03 10.3602 21.76 10.0902 21.43 10.0902L21.4 10.0702ZM11.82 6.9902C11.82 6.9902 11.78 6.9902 11.75 6.9902C9.89001 6.9902 8.82001 8.1302 8.81001 8.1402C8.64001 8.3302 8.40001 8.4302 8.16001 8.4302C7.95001 8.4302 7.74001 8.3602 7.58001 8.2102C7.22001 7.8902 7.19001 7.3302 7.51001 6.9702C7.57001 6.9002 9.15001 5.2002 11.85 5.2402C12.33 5.2402 12.72 5.6402 12.71 6.1302C12.71 6.6102 12.3 6.9702 11.82 6.9902ZM18.05 10.0102C18.05 10.4902 17.66 10.8902 17.17 10.8902C16.68 10.8902 16.29 10.5002 16.29 10.0102V9.2302C16.29 8.7502 16.68 8.3502 17.17 8.3502C17.66 8.3502 18.05 8.7402 18.05 9.2302V10.0102Z"
      fill="currentColor"
    />
  </svg>
`;

export const makeWalletIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_608_22333)">
      <path
        d="M20.65 6.50023H4.62C4.14 6.50023 3.75 6.11023 3.75 5.63023C3.75 5.15023 4.14 4.75023 4.63 4.75023H16.8C17.28 4.75023 17.68 4.36023 17.68 3.87023C17.68 3.38023 17.29 2.99023 16.8 2.99023H4.18C2.97 2.99023 2 3.97023 2 5.17023V19.6402C2 20.3802 2.6 20.9902 3.35 20.9902H20.66C21.4 20.9902 22.01 20.3902 22.01 19.6402V7.85023C22.01 7.11023 21.41 6.50023 20.66 6.50023H20.65ZM16.8 12.7502C17.35 12.7502 17.8 13.2002 17.8 13.7502C17.8 14.3002 17.35 14.7502 16.8 14.7502C16.25 14.7502 15.8 14.3002 15.8 13.7502C15.8 13.2002 16.25 12.7502 16.8 12.7502Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_608_22333">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;

export const makeSackMoneyIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_608_22338)">
      <path
        d="M16.6698 9.93982V7.16982C16.6698 5.17982 13.3898 3.56982 9.33977 3.56982C5.28977 3.56982 2.00977 5.17982 2.00977 7.16982V10.5998C2.00977 12.2498 4.26977 13.6398 7.33977 14.0598V16.8298C7.33977 18.8198 10.6198 20.4298 14.6698 20.4298C18.7198 20.4298 21.9998 18.8198 21.9998 16.8298V13.3998C21.9998 11.7498 19.7398 10.3598 16.6698 9.93982ZM12.3598 10.4398C13.3498 10.2198 14.2198 9.88982 14.9198 9.48982V10.5898C14.9198 10.8998 14.0198 11.6098 12.3598 12.0598V10.4398ZM8.05977 10.7098C8.46977 10.7498 8.89977 10.7698 9.32977 10.7698C9.75977 10.7698 10.1898 10.7498 10.6098 10.7098V12.3898C10.2098 12.4298 9.78977 12.4498 9.32977 12.4498C8.86977 12.4498 8.44977 12.4298 8.05977 12.3898V10.7098ZM6.30977 12.0698C4.64977 11.6198 3.74977 10.9098 3.74977 10.5998V9.49982C4.44977 9.89982 5.31977 10.2298 6.30977 10.4498V12.0698ZM8.37977 14.1698C8.32977 14.1698 8.27977 14.1698 8.21977 14.1598C8.26977 14.1598 8.31977 14.1598 8.37977 14.1698ZM11.6398 18.2998C9.97977 17.8498 9.07977 17.1398 9.07977 16.8298V15.7298C9.77977 16.1298 10.6498 16.4598 11.6398 16.6798V18.2998ZM15.9398 18.6298C15.5398 18.6698 15.1198 18.6898 14.6698 18.6898C14.2198 18.6898 13.7898 18.6698 13.3898 18.6298V16.9498C13.7998 16.9898 14.2298 17.0098 14.6698 17.0098C15.1098 17.0098 15.5298 16.9898 15.9398 16.9498V18.6298ZM20.2498 16.8298C20.2498 17.1398 19.3498 17.8498 17.6898 18.2998V16.6798C18.6798 16.4598 19.5498 16.1298 20.2498 15.7298V16.8298Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_608_22338">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;

export const makeOutLinkIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    class="${klass}"
  >
    <g clip-path="url(#clip0_1345_3538)">
      <path
        d="M17.13 13.12C16.65 13.12 16.25 13.51 16.25 14V20.25H3.75V7.75H10C10.48 7.75 10.88 7.36 10.88 6.87C10.88 6.38 10.49 5.99 10 5.99H3.7C2.76 5.99 2 6.75 2 7.69V20.29C2 21.23 2.76 21.99 3.7 21.99H16.3C17.24 21.99 18 21.23 18 20.29V13.99C18 13.51 17.61 13.11 17.12 13.11L17.13 13.12Z"
        fill="currentColor"
      />
      <path
        d="M21.93 2.54C21.84 2.33 21.67 2.16 21.46 2.07C21.35 2.03 21.24 2 21.13 2H12.63C12.15 2 11.75 2.39 11.75 2.88C11.75 3.37 12.14 3.76 12.63 3.76H19.02L12.01 10.77C11.67 11.11 11.67 11.67 12.01 12.01C12.18 12.18 12.4 12.27 12.63 12.27C12.86 12.27 13.08 12.18 13.25 12.01L20.26 5V11.39C20.26 11.87 20.65 12.27 21.14 12.27C21.63 12.27 22.02 11.88 22.02 11.39V2.88C22.02 2.77 22 2.65 21.95 2.55L21.93 2.54Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1345_3538">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;

export const makeConfirmIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_608_22350)">
      <path
        d="M19.0998 10.0002H8.74977V7.00023C8.74977 5.21023 10.2098 3.75023 11.9998 3.75023C12.9298 3.75023 13.8098 4.15023 14.4298 4.84023C14.6898 5.13023 14.8898 5.46023 15.0298 5.82023C15.1698 6.19023 15.2498 6.59023 15.2498 6.99023C15.2498 7.47023 15.6398 7.87023 16.1298 7.87023C16.6198 7.87023 17.0098 7.48023 17.0098 6.99023C17.0098 6.35023 16.8898 5.74023 16.6698 5.18023C16.4498 4.62023 16.1398 4.11023 15.7498 3.67023C14.8298 2.64023 13.4998 1.99023 12.0098 1.99023C9.24977 1.99023 7.00977 4.23023 7.00977 6.99023V9.99023H4.90977C4.13977 9.99023 3.50977 10.6202 3.50977 11.3902V20.5902C3.50977 21.3602 4.13977 21.9902 4.90977 21.9902H19.1098C19.8798 21.9902 20.5098 21.3602 20.5098 20.5902V11.3902C20.5098 10.6202 19.8798 9.99023 19.1098 9.99023L19.0998 10.0002ZM12.4998 16.1402V18.7802C12.4998 19.0602 12.2798 19.2802 11.9998 19.2802C11.7198 19.2802 11.4998 19.0602 11.4998 18.7802V16.1402C10.7798 15.9202 10.2498 15.2602 10.2498 14.4702C10.2498 13.5002 11.0298 12.7202 11.9998 12.7202C12.9698 12.7202 13.7498 13.5002 13.7498 14.4702C13.7498 15.2602 13.2198 15.9202 12.4998 16.1402Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_608_22350">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;

export const makeSalesIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.21943 2C3.67802 2 2.42847 3.24956 2.42847 4.79096V18.209C2.42847 19.7504 3.67802 21 5.21943 21H12.9563C14.0549 22.2275 15.6515 23 17.4285 23C20.7422 23 23.4285 20.3137 23.4285 17C23.4285 15.223 22.656 13.6264 21.4285 12.5278V4.79096C21.4285 3.24956 20.1789 2 18.6375 2H5.21943ZM11.4285 17C11.4285 17.9759 11.6615 18.8974 12.0748 19.7119H5.21943C4.38944 19.7119 3.7166 19.039 3.7166 18.209V4.79096C3.7166 3.96097 4.38944 3.28814 5.21943 3.28814H7.34839V7.47455C7.34839 8.42311 8.11735 9.19206 9.0659 9.19206H14.7909C15.7395 9.19206 16.5085 8.42311 16.5085 7.47455V3.28814H18.6375C19.4675 3.28814 20.1403 3.96097 20.1403 4.79096V11.6464C19.3259 11.233 18.4044 11 17.4285 11C14.1148 11 11.4285 13.6863 11.4285 17ZM15.2203 3.28814H8.63652V7.47455C8.63652 7.71169 8.82876 7.90393 9.0659 7.90393H14.7909C15.0281 7.90393 15.2203 7.71169 15.2203 7.47455V3.28814ZM17.4285 12.2857C14.8248 12.2857 12.7142 14.3964 12.7142 17C12.7142 19.6036 14.8248 21.7143 17.4285 21.7143C20.0321 21.7143 22.1428 19.6036 22.1428 17C22.1428 14.3964 20.0321 12.2857 17.4285 12.2857ZM19.9391 16.3548C20.1901 16.1038 20.1901 15.6967 19.9391 15.4457C19.688 15.1946 19.281 15.1946 19.03 15.4457L16.9592 17.5164L15.8355 16.3927C15.5844 16.1416 15.1774 16.1416 14.9263 16.3927C14.6753 16.6437 14.6753 17.0508 14.9263 17.3018L16.5047 18.8801C16.7557 19.1312 17.1627 19.1312 17.4138 18.8801L19.9391 16.3548Z"
      fill="currentColor"
    />
  </svg>
`;

export const makeCloseIcon = ({ html = runeHtml, klass = '' }: IconProps) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 21 20"
    fill="none"
  >
    <path
      d="M11.3342 10.0001L17.5672 3.75846C17.8585 3.4668 17.8585 3.00013 17.5672 2.7168C17.2759 2.42513 16.8099 2.42513 16.5187 2.7168L10.2856 8.95013L4.05264 2.7168C3.76137 2.42513 3.29535 2.42513 3.00409 2.7168C2.71283 3.00846 2.71283 3.47513 3.00409 3.75846L9.2371 10.0001L3.00409 16.2418C2.71283 16.5335 2.71283 17.0001 3.00409 17.2835C3.14556 17.4251 3.33696 17.5001 3.52836 17.5001C3.71976 17.5001 3.90284 17.4251 4.05264 17.2835L10.2856 11.0501L16.5187 17.2835C16.6601 17.4251 16.8515 17.5001 17.0429 17.5001C17.2343 17.5001 17.4174 17.4251 17.5672 17.2835C17.8585 16.9918 17.8585 16.5251 17.5672 16.2418L11.3342 10.0001Z"
      fill="currentColor"
    />
  </svg>
`;

export const makeRefundIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 21 20"
    fill="none"
  >
    <g clip-path="url(#clip0_5550_5304)">
      <path
        d="M12.5425 5.57454H4.25921L6.03421 3.79954C6.31755 3.51621 6.31755 3.04954 6.03421 2.76621C5.75088 2.48288 5.28421 2.48288 5.00088 2.76621L2.05088 5.71621C1.72588 6.04121 1.72588 6.56621 2.05088 6.89121L5.00088 9.84121C5.28421 10.1245 5.75088 10.1245 6.03421 9.84121C6.31755 9.55788 6.31755 9.09121 6.03421 8.80788L4.25921 7.03288H12.5425C15.0092 7.03288 17.0259 9.04121 17.0259 11.5162C17.0259 13.9912 15.0175 15.9995 12.5425 15.9995H6.00921C5.60921 15.9995 5.27588 16.3245 5.27588 16.7329C5.27588 17.1412 5.60088 17.4662 6.00921 17.4662H12.5425C15.8175 17.4662 18.4759 14.7995 18.4759 11.5329C18.4759 8.26621 15.8092 5.59954 12.5425 5.59954V5.57454Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_5550_5304">
        <rect width="20" height="20" fill="white" transform="translate(0.142822)" />
      </clipPath>
    </defs>
  </svg>
`;

export const makeMenuIcon = ({ html = runeHtml, klass = '' }: IconProps) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M2.88956 5.88C2.3998 5.88 2 5.49 2 5C2 4.51 2.3998 4.12 2.88956 4.12H21.1104C21.6002 4.12 22 4.51 22 5C22 5.49 21.6002 5.88 21.1104 5.88H2.88956Z"
      fill="currentColor"
    />
    <path
      d="M2.88956 12.88C2.3998 12.88 2 12.49 2 12C2 11.51 2.3998 11.12 2.88956 11.12H21.1104C21.6002 11.12 22 11.51 22 12C22 12.49 21.6002 12.88 21.1104 12.88H2.88956Z"
      fill="currentColor"
    />
    <path
      d="M2.88956 19.88C2.3998 19.88 2 19.49 2 19C2 18.51 2.3998 18.12 2.88956 18.12H21.1104C21.6002 18.12 22 18.51 22 19C22 19.49 21.6002 19.88 21.1104 19.88H2.88956Z"
      fill="currentColor"
    />
  </svg>
`;

export const makeBankIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    class="${klass}"
  >
    <path
      d="M21.1204 20.2408H2.87956C2.3998 20.2408 2 20.6308 2 21.1208C2 21.6108 2.38981 22.0008 2.87956 22.0008H21.1204C21.6002 22.0008 22 21.6108 22 21.1208C22 20.6308 21.6102 20.2408 21.1204 20.2408Z"
      fill="currentColor"
    />
    <path
      d="M2.87956 16.7408C2.3998 16.7408 2 17.1308 2 17.6208C2 18.1108 2.38981 18.5008 2.87956 18.5008H21.1204C21.6002 18.5008 22 18.1108 22 17.6208C22 17.1308 21.6102 16.7408 21.1204 16.7408H19.5012V10.0308H20.8206C21.89 10.0308 22.3998 8.58083 21.6302 7.98083C21.6302 7.98083 13.3343 2.57083 12.8146 2.24083C12.5447 2.07083 12.2849 1.99083 12.005 2.00083C11.7351 2.00083 11.4653 2.07083 11.1954 2.24083C10.6857 2.57083 2.37981 7.98083 2.37981 7.98083C1.6102 8.58083 2.10994 10.0308 3.1894 10.0308H4.50874V16.7408H2.87956ZM13.3243 11.6508C13.3243 11.1708 13.7141 10.7708 14.2039 10.7708C14.6936 10.7708 15.0835 11.1608 15.0835 11.6508V15.1008C15.0835 15.5808 14.6936 15.9808 14.2039 15.9808C13.7141 15.9808 13.3243 15.5908 13.3243 15.1008V11.6508ZM8.91654 11.6508C8.91654 11.1708 9.30634 10.7708 9.7961 10.7708C10.2859 10.7708 10.6757 11.1608 10.6757 11.6508V15.1008C10.6757 15.5808 10.2859 15.9808 9.7961 15.9808C9.30634 15.9808 8.91654 15.5908 8.91654 15.1008V11.6508Z"
      fill="currentColor"
    />
  </svg>
`;

export const makeSiteIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_608_22376)">
      <path
        d="M20.5 3H3.5C2.67 3 2 3.67 2 4.5V8H22V4.5C22 3.67 21.33 3 20.5 3ZM4.5 6.25C4.09 6.25 3.75 5.91 3.75 5.5C3.75 5.09 4.09 4.75 4.5 4.75C4.91 4.75 5.25 5.09 5.25 5.5C5.25 5.91 4.91 6.25 4.5 6.25ZM7.5 6.25C7.09 6.25 6.75 5.91 6.75 5.5C6.75 5.09 7.09 4.75 7.5 4.75C7.91 4.75 8.25 5.09 8.25 5.5C8.25 5.91 7.91 6.25 7.5 6.25Z"
        fill="currentColor"
      />
      <path
        d="M2 19.5C2 20.33 2.67 21 3.5 21H20.5C21.33 21 22 20.33 22 19.5V9.75H2V19.5Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_608_22376">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;

export const makeSmileIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM15.25 7.79C15.94 7.79 16.5 8.35 16.5 9.04C16.5 9.73 15.94 10.29 15.25 10.29C14.56 10.29 14 9.73 14 9.04C14 8.35 14.56 7.79 15.25 7.79ZM8.75 7.79C9.44 7.79 10 8.35 10 9.04C10 9.73 9.44 10.29 8.75 10.29C8.06 10.29 7.5 9.73 7.5 9.04C7.5 8.35 8.06 7.79 8.75 7.79ZM16.88 14.09C16.81 14.18 15.04 16.41 12 16.41C8.96 16.41 7.19 14.18 7.12 14.09C6.82 13.71 6.89 13.16 7.28 12.86C7.66 12.56 8.21 12.63 8.51 13.01C8.58 13.09 9.85 14.66 12.01 14.66C14.17 14.66 15.46 13.08 15.51 13.01C15.81 12.63 16.36 12.57 16.74 12.86C17.12 13.16 17.19 13.7 16.89 14.08L16.88 14.09Z"
      fill="currentColor"
    />
  </svg>
`;

export const makeInviteIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_608_22386)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M21.79 8.78L21.65 8.68L12.29 2.09C12.2 2.03 12.1 2 12 2C11.9 2 11.8 2.03 11.71 2.09L2.35 8.68L2.21 8.78C2.08 8.87 2 9.03 2 9.19V20.45C2 20.62 2.03 20.78 2.08 20.93C2.28 21.54 2.85 21.99 3.52 22C3.52 22 3.53 22 3.54 22H20.46C20.46 22 20.47 22 20.48 22C21.16 22 21.72 21.55 21.92 20.93C21.97 20.78 22 20.62 22 20.45V9.19C22 9.03 21.92 8.87 21.79 8.78ZM3.75 11.81L8.54 15.17L3.75 19.44V11.8V11.81ZM5.5 20.24L10.29 15.97H13.72L18.51 20.24H5.5ZM20.25 19.45L15.46 15.18L20.25 11.82V19.46V19.45Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_608_22386">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;

export const makeWaitIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_608_22392)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19 7.19V3.5C19 2.67 18.33 2 17.5 2H6.5C5.67 2 5 2.67 5 3.5V7.19C5 7.7 5.26 8.17 5.68 8.45L11.13 12.01L5.68 15.57C5.26 15.85 5 16.32 5 16.83V20.52C5 21.35 5.67 22.02 6.5 22.02H17.5C18.33 22.02 19 21.35 19 20.52V16.83C19 16.32 18.74 15.85 18.32 15.57L12.87 12.01L18.32 8.45C18.74 8.17 19 7.7 19 7.19ZM7.25 3.75H16.75C17.03 3.75 17.25 3.97 17.25 4.25V6.58C17.25 6.86 17.03 7.08 16.75 7.08H7.25C6.97 7.08 6.75 6.86 6.75 6.58V4.25C6.75 3.97 6.97 3.75 7.25 3.75ZM17.25 17.22V19.75C17.25 20.03 17.03 20.25 16.75 20.25H7.25C6.97 20.25 6.75 20.03 6.75 19.75V17.22C6.75 17.05 6.84 16.89 6.98 16.8L11.13 14.09V16.34C11.13 16.82 11.52 17.22 12.01 17.22C12.5 17.22 12.89 16.83 12.89 16.34V14.09L17.04 16.8C17.18 16.89 17.27 17.05 17.27 17.22H17.25Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_608_22392">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;

export const makeRejectIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_608_22398)">
      <path
        d="M18.5702 4.95H18.0002C18.0002 5.03 18.0202 5.11 18.0202 5.19V5.47C18.0202 6.71 17.0402 7.72 15.8302 7.72H8.16023C6.95023 7.72 5.97023 6.71 5.97023 5.47V5.19C5.97023 5.11 5.98023 5.03 5.99023 4.95H5.42023C4.77023 4.95 4.24023 5.5 4.24023 6.18V20.77C4.24023 21.45 4.77023 22 5.42023 22H18.5602C19.2102 22 19.7402 21.45 19.7402 20.77V6.18C19.7402 5.5 19.2102 4.95 18.5602 4.95H18.5702ZM15.2602 16.51C15.6002 16.85 15.6002 17.41 15.2602 17.75C15.0902 17.92 14.8702 18.01 14.6402 18.01C14.4102 18.01 14.1902 17.92 14.0202 17.75L12.0002 15.73L9.98023 17.75C9.81023 17.92 9.59023 18.01 9.36023 18.01C9.13023 18.01 8.91023 17.92 8.74023 17.75C8.40023 17.41 8.40023 16.85 8.74023 16.51L10.7602 14.49L8.74023 12.47C8.40023 12.13 8.40023 11.57 8.74023 11.23C9.08023 10.89 9.64023 10.89 9.98023 11.23L12.0002 13.25L14.0202 11.23C14.3602 10.89 14.9202 10.89 15.2602 11.23C15.6002 11.57 15.6002 12.13 15.2602 12.47L13.2402 14.49L15.2602 16.51Z"
        fill="currentColor"
      />
      <path
        d="M16.0102 4.47L15.1302 3.47C14.9602 3.28 14.7402 3.18 14.5102 3.18H13.2702C13.2102 2.52 12.6802 2 12.0102 2C11.3402 2 10.8002 2.52 10.7502 3.18H9.51023C9.28023 3.18 9.05023 3.29 8.89023 3.47L8.01023 4.47C7.84023 4.66 7.75023 4.91 7.75023 5.18V5.46C7.75023 5.73 7.95023 5.96 8.19023 5.96H15.8602C16.1002 5.96 16.3002 5.74 16.3002 5.46V5.18C16.3002 4.91 16.2102 4.66 16.0402 4.47H16.0102Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_608_22398">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;

export const makeContentsIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_608_22404)">
      <path
        d="M3.66016 6.39C3.11016 6.39 2.66016 6.84 2.66016 7.39V21C2.66016 21.55 3.11016 22 3.66016 22H15.9602C16.5102 22 16.9602 21.55 16.9602 21V7.39C16.9602 6.84 16.5102 6.39 15.9602 6.39H3.66016ZM12.9302 19.56H6.67016C6.19016 19.56 5.79016 19.17 5.79016 18.68C5.79016 18.19 6.18016 17.8 6.67016 17.8H12.9302C13.4102 17.8 13.8102 18.19 13.8102 18.68C13.8102 19.17 13.4202 19.56 12.9302 19.56ZM12.9302 15.07H6.67016C6.19016 15.07 5.79016 14.68 5.79016 14.19C5.79016 13.7 6.18016 13.31 6.67016 13.31H12.9302C13.4102 13.31 13.8102 13.7 13.8102 14.19C13.8102 14.68 13.4202 15.07 12.9302 15.07ZM12.9302 10.58H6.67016C6.19016 10.58 5.79016 10.19 5.79016 9.7C5.79016 9.21 6.18016 8.82 6.67016 8.82H12.9302C13.4102 8.82 13.8102 9.21 13.8102 9.7C13.8102 10.19 13.4202 10.58 12.9302 10.58Z"
        fill="currentColor"
      />
      <path
        d="M20.3402 2H8.04016C7.49016 2 7.04016 2.45 7.04016 3V4.64H18.0802C18.4202 4.64 18.7002 4.92 18.7002 5.26V17.61H20.3402C20.8902 17.61 21.3402 17.16 21.3402 16.61V3C21.3402 2.45 20.8902 2 20.3402 2Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_608_22404">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;

export const makeThumbsIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_2877_12307)">
      <path
        d="M21.9002 9.5798C21.8102 9.2898 21.6602 9.0198 21.4602 8.7898C21.2602 8.5598 21.0102 8.3798 20.7302 8.2498C20.4502 8.1298 20.1502 8.0598 19.8502 8.0598H14.8502V6.6298C14.8502 5.6798 14.4702 4.7698 13.8002 4.0998C13.1302 3.4298 12.2202 3.0498 11.2702 3.0498C11.1402 3.0498 11.0102 3.0898 10.8902 3.1598C10.7802 3.2298 10.6902 3.3298 10.6302 3.4498L7.26023 10.1998H3.62023C2.72023 10.1998 1.99023 10.9298 1.99023 11.8298V19.2798C1.99023 20.1798 2.72023 20.9098 3.62023 20.9098H18.7702C19.2902 20.9098 19.8002 20.7198 20.1902 20.3698C20.5802 20.0198 20.8302 19.5498 20.9002 19.0298L21.9702 10.4598C22.0102 10.1598 21.9802 9.8498 21.8902 9.5598L21.9002 9.5798ZM7.27023 19.1798H3.75023V11.9698H7.27023V19.1798Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_2877_12307">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;

export const makeReceiptIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M20.97 5.10002C20.91 4.83002 20.78 4.58002 20.59 4.39002C20.53 4.33002 20.46 4.27002 20.38 4.22002C20.16 4.07002 19.89 3.98002 19.6 3.98002H17.84C17.69 2.88002 16.74 2.02002 15.6 2.02002H8.4C7.25 2.02002 6.31 2.88002 6.16 3.98002H4.4C3.63 3.98002 3 4.61002 3 5.38002V20.58C3 21.35 3.63 21.98 4.4 21.98H19.6C20.37 21.98 21 21.35 21 20.58V5.38002C21 5.28002 21 5.19002 20.97 5.10002ZM7.88 4.29002C7.88 4.00002 8.12 3.77002 8.41 3.77002H15.61C15.9 3.77002 16.14 4.01002 16.14 4.29002V5.49002C16.14 5.78002 15.9 6.01002 15.61 6.01002H8.41C8.12 6.01002 7.88 5.77002 7.88 5.49002V4.29002ZM15.63 14.33L11.96 18.13C11.8 18.3 11.57 18.4 11.33 18.4C11.09 18.4 10.87 18.3 10.7 18.13L8.37 15.72C8.03 15.37 8.04 14.82 8.39 14.48C8.74 14.15 9.29 14.15 9.63 14.5L11.33 16.26L14.37 13.11C14.7 12.76 15.26 12.75 15.61 13.09C15.96 13.43 15.97 13.98 15.63 14.33ZM19.25 9.83002C19.25 10.05 19.07 10.23 18.85 10.23H5.15C4.93 10.23 4.75 10.05 4.75 9.83002V6.13002C4.75 6.07002 4.76 6.02002 4.78 5.97002C4.84 5.83002 4.98 5.73002 5.15 5.73002H6.15C6.27 6.87002 7.23 7.77002 8.4 7.77002H15.6C16.77 7.77002 17.73 6.87002 17.85 5.73002H18.85C19.07 5.73002 19.25 5.91002 19.25 6.13002V9.83002Z"
      fill="currentColor"
    />
  </svg>
`;

export const makeInProductionIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_3445_9996)">
      <path
        d="M21.7899 9.1L18.4199 5.01C18.1499 4.69 17.7599 4.5 17.3399 4.5H15.8699C15.6599 4.5 15.4999 4.67 15.4799 4.87C15.2899 6.62 13.8099 7.99 11.9999 7.99C10.1899 7.99 8.70991 6.62 8.51991 4.87C8.49991 4.66 8.33991 4.5 8.12991 4.5H6.65991C6.23991 4.5 5.84991 4.69 5.57991 5.01L2.20991 9.1C1.96991 9.41 1.92991 9.83 2.10991 10.17L3.95991 13.78C4.12991 14.11 4.46991 14.32 4.84991 14.32H5.99991V20.6C5.99991 21.37 6.62991 22 7.39991 22H16.5999C17.3699 22 17.9999 21.37 17.9999 20.6V14.32H19.1499C19.5199 14.32 19.8699 14.11 20.0399 13.78L21.8899 10.17C22.0699 9.82 22.0299 9.4 21.7899 9.1ZM5.30991 12.57L3.88991 9.81L5.99991 7.25V12.57H5.30991ZM18.6899 12.57H17.9999V7.25L20.1099 9.81L18.6899 12.57Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3445_9996">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;

export const makePreparingIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M20.89 6.28L12.89 2.21C12.61 2.07 12.31 2 12 2C11.69 2 11.39 2.07 11.11 2.21L3.11 6.28C2.43 6.63 2 7.34 2 8.11V15.89C2 16.67 2.43 17.38 3.11 17.72L11.11 21.78C11.39 21.92 11.69 21.99 12 21.99C12.31 21.99 12.61 21.92 12.89 21.78L20.89 17.72C21.57 17.37 22 16.66 22 15.89V8.11C22 7.33 21.57 6.62 20.89 6.28ZM11.9 3.77C11.9 3.77 11.96 3.75 12 3.75C12.04 3.75 12.07 3.75 12.1 3.77L19.21 7.38L16.63 8.68L9.81 4.83L11.9 3.77ZM4.79 7.39L7.94 5.79L14.75 9.64L12 11.02L4.79 7.39ZM20.25 15.89C20.25 16.01 20.19 16.12 20.1 16.16L12.88 19.83V12.54L15.73 11.1V14.09C15.73 14.57 16.12 14.97 16.61 14.97C17.1 14.97 17.49 14.58 17.49 14.09V10.22L20.26 8.82V15.89H20.25Z"
      fill="currentColor"
    />
  </svg>
`;

export const makeDeliveryIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M21.84 13.0801L19.21 7.99012C18.97 7.53012 18.49 7.23012 17.97 7.23012H17V4.77012C17 4.00012 16.37 3.37012 15.6 3.37012H3.4C2.63 3.37012 2 4.00012 2 4.77012V15.9701C2 16.7401 2.63 17.3701 3.4 17.3701H3.75C3.75 19.1601 5.21 20.6201 7 20.6201C7.45 20.6201 7.88 20.5301 8.27 20.3601C8.66 20.2001 9.01 19.9601 9.3 19.6601C9.89 19.0701 10.25 18.2601 10.25 17.3601H13.35C13.35 19.1501 14.81 20.6101 16.6 20.6101C17.05 20.6101 17.48 20.5201 17.87 20.3501C18.26 20.1901 18.61 19.9501 18.9 19.6501C19.49 19.0601 19.85 18.2501 19.85 17.3501H20.6C21.37 17.3501 22 16.7201 22 15.9501V13.7001C22 13.4801 21.95 13.2601 21.84 13.0601V13.0801ZM7 18.8801C6.17 18.8801 5.5 18.2101 5.5 17.3801C5.5 16.5501 6.17 15.8801 7 15.8801C7.83 15.8801 8.5 16.5501 8.5 17.3801C8.5 18.2101 7.83 18.8801 7 18.8801ZM14.12 7.15012H4.88C4.4 7.15012 4 6.76012 4 6.27012C4 5.78012 4.39 5.39012 4.88 5.39012H14.13C14.61 5.39012 15.01 5.78012 15.01 6.27012C15.01 6.76012 14.62 7.15012 14.13 7.15012H14.12ZM16.6 18.8801C15.77 18.8801 15.1 18.2101 15.1 17.3801C15.1 16.5501 15.77 15.8801 16.6 15.8801C17.43 15.8801 18.1 16.5501 18.1 17.3801C18.1 18.2101 17.43 18.8801 16.6 18.8801ZM19.15 12.4401H17V8.99012H17.34C17.34 8.99012 17.74 8.96012 17.97 9.41012L19.36 12.1001C19.44 12.2601 19.33 12.4401 19.15 12.4401Z"
      fill="currentColor"
    />
  </svg>
`;

export const makeCompletedIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M20.89 6.28L12.89 2.21C12.61 2.07 12.31 2 12 2C11.69 2 11.39 2.07 11.11 2.21L3.11 6.28C2.43 6.63 2 7.34 2 8.11V13.71C2 14.04 2.37 14.22 2.64 14.02C3.79 13.16 5.3 12.77 6.91 13.11C8.85 13.53 10.43 15.09 10.87 17.03C11.19 18.44 10.86 19.74 10.29 20.87C10.1 21.26 10.42 21.42 10.42 21.42L11.12 21.77C11.4 21.91 11.7 21.98 12.01 21.98C12.32 21.98 12.62 21.91 12.9 21.77L20.9 17.71C21.58 17.36 22.01 16.65 22.01 15.88V8.1C22.01 7.32 21.58 6.61 20.9 6.27L20.89 6.28ZM11.9 3.77C11.9 3.77 11.96 3.75 12 3.75C12.04 3.75 12.07 3.75 12.1 3.77L19.21 7.38L16.63 8.68L9.81 4.83L11.9 3.77ZM4.79 7.39L7.94 5.79L14.75 9.64L12 11.02L4.79 7.39ZM20.26 15.89H20.25C20.25 16.01 20.19 16.12 20.1 16.16L12.88 19.83V12.54L15.73 11.1V14.09C15.73 14.57 16.12 14.97 16.61 14.97C17.1 14.97 17.49 14.58 17.49 14.09V10.22L20.26 8.82V15.89Z"
      fill="currentColor"
    />
    <path
      d="M5.75 14.5C3.68 14.5 2 16.18 2 18.25C2 20.32 3.68 22 5.75 22C7.82 22 9.5 20.32 9.5 18.25C9.5 16.18 7.82 14.5 5.75 14.5ZM7.7 17.96L5.85 19.84C5.73 19.96 5.57 20.03 5.4 20.03C5.23 20.03 5.07 19.96 4.95 19.84L3.78 18.65C3.54 18.4 3.54 18.01 3.78 17.77C4.03 17.53 4.42 17.53 4.66 17.77L5.38 18.51L6.78 17.08C7.02 16.83 7.42 16.83 7.66 17.08C7.91 17.32 7.91 17.72 7.66 17.96H7.7Z"
      fill="currentColor"
    />
  </svg>
`;

export const makeConfirmationIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_3434_9978)">
      <path
        d="M20.74 9.75C20.4 9.4 20.06 9.04 19.92 8.72C19.8 8.43 19.79 7.94 19.78 7.48C19.77 6.61 19.75 5.62 19.07 4.93C18.39 4.24 17.4 4.23 16.52 4.22C16.05 4.22 15.57 4.21 15.28 4.08C14.96 3.95 14.6 3.6 14.25 3.26C13.63 2.67 12.93 2 12 2C11.07 2 10.37 2.67 9.75 3.26C9.4 3.6 9.04 3.94 8.72 4.08C8.43 4.2 7.94 4.21 7.48 4.22C6.61 4.23 5.62 4.25 4.93 4.93C4.24 5.61 4.23 6.6 4.22 7.48C4.22 7.95 4.21 8.43 4.08 8.72C3.95 9.04 3.6 9.4 3.26 9.75C2.67 10.37 2 11.07 2 12C2 12.93 2.67 13.63 3.26 14.25C3.6 14.6 3.94 14.96 4.08 15.28C4.2 15.57 4.21 16.06 4.22 16.52C4.23 17.39 4.25 18.38 4.93 19.07C5.62 19.76 6.6 19.77 7.48 19.78C7.95 19.78 8.43 19.79 8.72 19.92C9.04 20.05 9.4 20.4 9.75 20.74C10.37 21.33 11.07 22 12 22C12.93 22 13.63 21.33 14.25 20.74C14.6 20.4 14.96 20.06 15.28 19.92C15.57 19.8 16.06 19.79 16.52 19.78C17.39 19.77 18.38 19.75 19.07 19.07C19.76 18.38 19.77 17.4 19.78 16.52C19.78 16.05 19.79 15.57 19.92 15.28C20.05 14.96 20.4 14.6 20.74 14.25C21.33 13.63 22 12.93 22 12C22 11.07 21.33 10.37 20.74 9.75ZM16.74 10.09L11.77 15.29C11.58 15.49 11.32 15.6 11.05 15.6C10.78 15.6 10.52 15.49 10.33 15.29L7.26 12.08C6.88 11.68 6.89 11.05 7.29 10.67C7.69 10.29 8.32 10.3 8.7 10.7L11.05 13.15L15.3 8.71C15.68 8.31 16.32 8.3 16.71 8.68C17.11 9.06 17.12 9.69 16.74 10.09Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3434_9978">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;

export const makeNavSalesIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.75 14.5C3.68 14.5 2 16.18 2 18.25C2 20.32 3.68 22 5.75 22C7.82 22 9.5 20.32 9.5 18.25C9.5 16.18 7.82 14.5 5.75 14.5ZM7.7 17.96L5.85 19.84C5.73 19.96 5.57 20.03 5.4 20.03C5.23 20.03 5.07 19.96 4.95 19.84L3.78 18.65C3.54 18.4 3.54 18.01 3.78 17.77C4.03 17.53 4.42 17.53 4.66 17.77L5.38 18.51L6.78 17.08C7.02 16.83 7.42 16.83 7.66 17.08C7.91 17.32 7.91 17.72 7.66 17.96H7.7Z"
      fill="currentColor"
    />
    <path
      d="M21.7899 7.6L18.4199 3.51C18.1499 3.19 17.7599 3 17.3399 3H15.8699C15.6599 3 15.4999 3.17 15.4799 3.37C15.2899 5.12 13.8099 6.49 11.9999 6.49C10.1899 6.49 8.70991 5.12 8.51991 3.37C8.49991 3.16 8.33991 3 8.12991 3H6.65991C6.23991 3 5.84991 3.19 5.57991 3.51L2.20991 7.6C1.96991 7.91 1.92991 8.33 2.10991 8.67L3.95991 12.5C4.12991 12.83 4.46991 13.04 4.84991 13.04H5.99991C8.76991 13.17 10.9799 15.44 10.9799 18.25C10.9799 19.26 10.6799 20.2 10.1799 21H16.5999C17.3699 21 17.9999 20.37 17.9999 19.6V13.04H19.1499C19.5199 13.04 19.8699 12.83 20.0399 12.5L21.8899 8.67C22.0699 8.32 22.0299 7.9 21.7899 7.6ZM5.99991 11.29H5.30991L3.88991 8.31L5.99991 5.75V11.29ZM18.6899 11.29H17.9999V5.75L20.1099 8.31L18.6899 11.29Z"
      fill="currentColor"
    />
  </svg>
`;

export const makeMembershipIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="${klass}"
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M2.34964 9.28452H5.07243C5.17996 9.28452 5.27715 9.34858 5.31954 9.4474L7.70312 15.0035C7.82239 15.2815 7.46276 15.5142 7.25805 15.2915L2.15167 9.73536C1.99325 9.56297 2.11552 9.28452 2.34964 9.28452ZM9.81808 3.41621L6.84697 7.82894C6.72672 8.00754 6.8547 8.248 7.07002 8.248H13.0139C13.2293 8.248 13.3573 8.00748 13.2369 7.82888L10.2641 3.41615C10.1575 3.25792 9.92464 3.25795 9.81808 3.41621ZM5.39555 8.12928L8.78523 3.09484C8.90548 2.91624 8.77751 2.67578 8.56219 2.67578H5.09729C4.84122 2.67578 4.61042 2.82761 4.5097 3.06346L1.70152 7.8429C1.59621 8.02215 1.72546 8.248 1.93336 8.248H5.17252C5.26198 8.248 5.34558 8.20349 5.39555 8.12928ZM14.7614 9.44561L12.363 14.9262C12.2412 15.2044 12.6018 15.4395 12.8073 15.216L17.8442 9.73536C18.0026 9.56297 17.8804 9.28452 17.6462 9.28452H15.0077C14.9009 9.28452 14.8042 9.34775 14.7614 9.44561ZM13.2897 9.28452H6.78549C6.59242 9.28452 6.46227 9.48197 6.53838 9.65941L9.75812 17.1646C9.85091 17.3809 10.1572 17.382 10.2515 17.1664L13.536 9.66121C13.6137 9.48356 13.4836 9.28452 13.2897 9.28452ZM14.898 2.67579H11.5201C11.3048 2.67579 11.1768 2.91631 11.2971 3.09491L14.6888 8.12935C14.7388 8.20352 14.8224 8.248 14.9118 8.248H18.0614C18.2694 8.248 18.3986 8.022 18.2932 7.84275L15.516 3.12315C15.3854 2.8286 15.1547 2.67579 14.898 2.67579Z"
      fill="currentColor"
    />
  </svg>
`;
